export default __webpack_public_path__ + "static/media/DNo.25-0.a8dd723a.jpg";